<template>
  <div class="EnvMonitor">
    <DataPagination
      v-if="envMonitorData?.length > 2"
      :listData="dealData(envMonitorData)"
      className="envMonitorSwitch"
      classNameTitleTipsItem="envMonitorTitleTipsItem"
      :splitNum="1"
      :showName="false"
      smallPagination
    />
    <TitleTipsItem
      v-else
      :listData="envMonitorData || []"
      :modalFlag="1"
      className="envMonitorTitleTipsItem"
    />
  </div>
</template>

<script>
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
import DataPagination from "@/components/zixitong/airSystem/DataPagination.vue";
export default {
  name: "EnvMonitor",
  props: {
    envMonitorData: {
      type: Array,
      default: () => [],
    },
  },
  components: {TitleTipsItem,DataPagination},
  data() {
    return {};
  },
  computed: {},
  methods: {
    //将2个value组成一组
    dealData(data) {
      const newData = [];
      let obj = { name: 1, value: [] };
      Array.isArray(data) &&
        data.forEach((element, index) => {
          obj.value.push(element);
          if (index % 2 == 1 ||index === data.length-1) {
            newData.push(obj);
            obj = { name: index, value: [] };
          }
        });
      return newData;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.EnvMonitor {
  width: 100%;
  height: 100%;
  ::v-deep .envMonitorSwitch {
    height: 100%;
  }
  ::v-deep .envMonitorTitleTipsItem {
    justify-content: space-between;
    &>div{
        width: 180px;
    }
  }
}
</style>
